module.exports = __webpack_public_path__ + "img/11.bbbf110c.jpg";